export const urls = {
  USD_AMOUNT: 'https://nbu.uz/en/exchange-rates/json/',
}
